export function preventEvDefault() {
  return function decorate(_target: any, _key: any, descriptor: any) {
    const origFn = descriptor.value;

    descriptor.value = async function decorated(ev: any, ...args: any[]) {
      ev.preventDefault();
      await origFn.call(this, ev, ...args);
    };
    return descriptor;
  };
}
